/****************************************************
 * Module Name:  labTest.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import * as React from "react";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import { useMediaQuery } from "@mui/material";
import NoPermission from "../common/noPermission";
import Offer from "./offer";
import OfferStone from "./offerStone";
import GroupIcon from '@mui/icons-material/Group';
import DiamondIcon from '@mui/icons-material/Diamond';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 1 }}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
    value: index,
  };
}

export default function OfferTab() {
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const matches = useMediaQuery("(min-width:1500px)");

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    value === 10 ? <NoPermission /> :
      <Box sx={{ bgcolor: "background.paper", width: "100%", padding: "10px" }}>
        <AppBar position="static" sx={{ bgcolor: "#03a9f4", height: 50 }}>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="secondary"
            textColor="inherit"
            variant={matches ? "fullWidth" : "scrollable"}
            scrollButtons="auto"
            aria-label="full width tabs example"
            sx={{
              "& .css-1vw5i9y-MuiButtonBase-root-MuiTab-root": {
                color: "#212121",
                fontWeight: "bold",
                textAlign: 'center'
              },
              "& .MuiTab-root": {
                paddingBottom: 4
              },
              "& .Mui-selected": {
                bgcolor: "#0277bd !important",
                color: "#fafafa !important",
                fontWeight: "bold !important",
                paddingBottom: 4
              }
            }}
            TabIndicatorProps={{ style: { background: "#0277bd" } }}
          >
            <Tab
              icon={<GroupIcon />}
              iconPosition="start"
              label="Offer wise"
              {...a11yProps(0)}
            />
            <Tab
              icon={<DiamondIcon />}
              iconPosition="start"
              label="Stone Wise"
              {...a11yProps(1)}
            />
          </Tabs>
        </AppBar>
        <SwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={value}
          onChangeIndex={handleChangeIndex}
        >

          <TabPanel value={value} index={0}>
            <Offer />
          </TabPanel>

          <TabPanel value={value} index={1}>
            <OfferStone />
          </TabPanel>

        </SwipeableViews>
      </Box>
  );
}
